import { IFolderDropdownData } from './types';

interface IHierarchy extends IFolderDropdownData {
    children: IHierarchy[];
    displayItem?: boolean;
}

export const searchFlatStructure = (nodes: IFolderDropdownData[], search: string): IFolderDropdownData[] => {
    const hierarchy = buildHierarchy(nodes, '0');
    const regex = RegExp(search, 'ig');
    return searchHierarchy(hierarchy, regex);
};

const buildHierarchy = (nodes: IFolderDropdownData[], parentID: string): IHierarchy[] => {
    const results: IHierarchy[] = [];

    const items = nodes.filter((e) => e.parentId === parentID);
    items.forEach((item) => {
        results.push({
            ...item,
            children: buildHierarchy(nodes, item.id),
        });
    });

    return results;
};

const searchHierarchy = (nodes: IHierarchy[], regex: RegExp): IFolderDropdownData[] => {
    const result = recursiveSearch(nodes, regex);
    const flattenItems: IFolderDropdownData[] = [];

    const pushItem = (nodes: IHierarchy[]) => {
        nodes.forEach((e) => {
            if (e.children) {
                pushItem(e.children);
            }
            if (e.displayItem) {
                flattenItems.push({
                    caption: e.caption,
                    id: e.id,
                    parentId: e.parentId,
                });
            }
        });
    };

    pushItem(result);

    return flattenItems;
};

const recursiveSearch = (items: IHierarchy[], regex: RegExp): IHierarchy[] => {
    items.forEach((e) => {
        if (e.children && e.children.length > 0) {
            const children = recursiveSearch(e.children, regex);
            if (children.find((e) => e.displayItem)) {
                e.displayItem = true;
            }
        } else {
            if (e.caption.match(regex)) {
                e.displayItem = true;
            }
        }
    });

    return items;
};
